module.exports = __webpack_public_path__ + "static/media/use-nose-rag.7d2ecc2b.svg";